import { defineMessages } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

type MessageKey =
  | 'personalFolderAriaLabel'
  | 'sharedFolderAriaLabel'
  | 'defaultFolderAriaLabel';

const messages: Record<MessageKey, MessageDescriptor> = defineMessages({
  personalFolderAriaLabel: {
    id: 'form.builder.fileSelection.contentField.personalFolderAriaLabel',
    description: 'Aria Label for Personal Folder Icon',
    defaultMessage: 'Personal Folder Icon',
  },
  sharedFolderAriaLabel: {
    id: 'form.builder.fileSelection.contentField.sharedFolderAriaLabel',
    description: 'Aria Label for Shared Folder Icon',
    defaultMessage: 'Shared Folder Icon',
  },
  defaultFolderAriaLabel: {
    id: 'form.builder.fileSelection.contentField.defaultFolderAriaLabel',
    description: 'Aria Label for Default Folder Icon',
    defaultMessage: 'Default Folder Icon',
  },
});

export default messages;
